// Popup modals for [data-popup] trigger buttons. Each trigger's data-popup
// value ("digest", "analytics", "consulting", "event") maps to its own
// #igs-popup-{value} element rendered in footer.php — each with distinct
// heading/copy/context, rather than all triggers sharing one generic form.
export function initPopups() {
	const popups = document.querySelectorAll('.popup[data-popup-id]');
	if (!popups.length) return;

	function open(popup) {
		popup.classList.add('is-open');
		document.body.classList.add('no-scroll');
	}

	function close(popup) {
		popup.classList.remove('is-open');
		document.body.classList.remove('no-scroll');
	}

	document.querySelectorAll('[data-popup]').forEach((trigger) => {
		const target = document.getElementById('igs-popup-' + trigger.dataset.popup);
		if (!target) return;
		trigger.addEventListener('click', () => open(target));
	});

	popups.forEach((popup) => {
		popup.querySelector('[data-popup-close]')?.addEventListener('click', () => close(popup));
		popup.addEventListener('click', (e) => {
			if (e.target === popup) close(popup);
		});
	});

	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		popups.forEach((popup) => close(popup));
	});
}
